import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import * as actions from '../actions';

class AAPlayerWrapper extends Component {
	constructor(props) {
		super(props);
		this.aaPlayer = null;
		this.aaPlayerContainer = null;
	}

	componentDidMount() {
		const { startRecording, stopRecording, audioURL, listenPath } = this.props;

		this.aaPlayer = new window.loader.components.AAPlayer(
			this.aaPlayerContainer,
			{
				onRecordStart: startRecording,
				onRecordFinish: stopRecording
			},
			audioURL,
			listenPath
		);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.disableRecord) {
			this.aaPlayer.disableRecord();
		} else {
			this.aaPlayer.enableRecord();
		}
	}

	render() {
		return <div className="AAPlayer" ref={(el) => this.aaPlayerContainer = el} />;
	}
}

AAPlayerWrapper.propTypes = {
	startRecording: PropTypes.func.isRequired,
	stopRecording: PropTypes.func.isRequired,
	disableRecord: PropTypes.bool.isRequired,
	itemIndex: PropTypes.number.isRequired, // eslint-disable-line
	audioURL: PropTypes.string,
	listenPath: PropTypes.string
};

AAPlayerWrapper.defaultProps = {
	audioURL: undefined,
	listenPath: undefined
};

const mapStateToProps = ({ loader: { testSent, itemsKeys, itemsWithAudio } }, ownProps) => ({
	audioURL:
		itemsWithAudio[ownProps.itemIndex] ?
			`${window.NL_CONFIG.api.url}/audioanalysis/url?key=${itemsKeys[ownProps.itemIndex]}&sessionCookieName=${window.discovia.directory}` :
			undefined,
	disableRecord: testSent
});

export default compose(
	connect(mapStateToProps, actions)
)(AAPlayerWrapper);
